import { render } from "./Prize.vue?vue&type=template&id=2e76d4c2&scoped=true"
import script from "./Prize.vue?vue&type=script&lang=ts"
export * from "./Prize.vue?vue&type=script&lang=ts"

import "./Prize.vue?vue&type=style&index=0&id=2e76d4c2&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-2e76d4c2"

export default script